const comparatifData = [
  // Orange Côte d'Ivoire
  {
    id: 1,
    networkId: 1, // Orange
    title: "Pass Internet Jour",
    description: "500 Mo à 500 FCFA",
    validUntil: "1 jour",
    code: "*144*4#",
    type: "Internet"
  },
  {
    id: 2,
    networkId: 1, // Orange
    title: "Pass Internet Semaine",
    description: "2 Go à 2000 FCFA",
    validUntil: "7 jours",
    code: "*144*4#",
    type: "Internet"
  },
  {
    id: 3,
    networkId: 1, // Orange
    title: "Pass Internet Mois",
    description: "20 Go à 10000 FCFA",
    validUntil: "30 jours",
    code: "*144*4#",
    type: "Internet"
  },

  // Moov Africa Côte d'Ivoire
  {
    id: 11,
    networkId: 3, // Moov
    title: "Forfait Internet",
    description: "150 Mo à 150 FCFA",
    validUntil: "Non spécifié",
    code: "*303*3#",
    type: "Internet"
  },
  {
    id: 12,
    networkId: 3, // Moov
    title: "Forfait Internet",
    description: "750 Mo à 500 FCFA",
    validUntil: "Non spécifié",
    code: "*303*3#",
    type: "Internet"
  },
  {
    id: 13,
    networkId: 3, // Moov
    title: "Forfait Internet",
    description: "1,5 Go à 1000 FCFA",
    validUntil: "Non spécifié",
    code: "*303*3#",
    type: "Internet"
  },
  {
    id: 14,
    networkId: 3, // Moov
    title: "Forfait Internet",
    description: "3 Go à 2000 FCFA",
    validUntil: "Non spécifié",
    code: "*303*3#",
    type: "Internet"
  },{
    id: 15,
    networkId: 1, // Orange
    title: "Forfait Appels Journalier",
    description: "30 minutes à 500 FCFA",
    validUntil: "24 heures",
    code: "*144*1#",
    type: "Appels"
  },
  {
    id: 16,
    networkId: 2, // MTN
    title: "Forfait Appels Weekend",
    description: "2 heures à 1000 FCFA",
    validUntil: "48 heures",
    code: "*123*2#",
    type: "Appels"
  },
  {
    id: 17,
    networkId: 3, // Moov
    title: "Forfait Appels Semaine",
    description: "5 heures à 2500 FCFA",
    validUntil: "7 jours",
    code: "*303*1#",
    type: "Appels"
  },
  {
    id: 18,
    networkId: 1, // Orange
    title: "Forfait Appels Illimités",
    description: "Appels illimités à 5000 FCFA",
    validUntil: "30 jours",
    code: "*144*5#",
    type: "Appels"
  },
  {
    id: 19,
    networkId: 2, // MTN
    title: "Forfait Appels Soirée",
    description: "3 heures à 1500 FCFA",
    validUntil: "De 22h à 6h",
    code: "*123*3#",
    type: "Appels"
  },
  {
    id: 20,
    networkId: 3, // Moov
    title: "Forfait Appels Famille",
    description: "10 heures à 4000 FCFA",
    validUntil: "15 jours",
    code: "*303*2#",
    type: "Appels"
  },{
    id: 21,
    networkId: 1, // Orange
    title: "Forfait SMS Journalier",
    description: "100 SMS à 200 FCFA",
    validUntil: "24 heures",
    code: "*144*2#",
    type: "SMS"
  },
  {
    id: 22,
    networkId: 2, // MTN
    title: "Forfait SMS Weekend",
    description: "500 SMS à 500 FCFA",
    validUntil: "48 heures",
    code: "*123*4#",
    type: "SMS"
  },
  {
    id: 23,
    networkId: 3, // Moov
    title: "Forfait SMS Semaine",
    description: "1000 SMS à 1000 FCFA",
    validUntil: "7 jours",
    code: "*303*4#",
    type: "SMS"
  },
  {
    id: 24,
    networkId: 1, // Orange
    title: "Forfait SMS Illimités",
    description: "SMS illimités à 3000 FCFA",
    validUntil: "30 jours",
    code: "*144*6#",
    type: "SMS"
  },
  {
    id: 25,
    networkId: 2, // MTN
    title: "Forfait SMS Soirée",
    description: "200 SMS à 300 FCFA",
    validUntil: "De 22h à 6h",
    code: "*123*5#",
    type: "SMS"
  },
  {
    id: 26,
    networkId: 3, // Moov
    title: "Forfait SMS Mensuel",
    description: "3000 SMS à 2500 FCFA",
    validUntil: "30 jours",
    code: "*303*5#",
    type: "SMS"
  },{
    id: 27,
    networkId: 2, // MTN
    title: "Forfait Internet Journalier",
    description: "1 Go à 500 FCFA",
    validUntil: "24 heures",
    code: "*123*1#",
    type: "Internet"
  },
  {
    id: 28,
    networkId: 2, // MTN
    title: "Forfait Internet Hebdomadaire",
    description: "5 Go à 2000 FCFA",
    validUntil: "7 jours",
    code: "*123*7#",
    type: "Internet"
  },
  {
    id: 29,
    networkId: 2, // MTN
    title: "Forfait Internet Illimité",
    description: "Internet illimité à 15000 FCFA",
    validUntil: "30 jours",
    code: "*123*30#",
    type: "Internet"
  },// MTN Côte d'Ivoire
  {
    id: 6,
    networkId: 2, // MTN
    title: "Pack Free Mini",
    description: "10 min, 15 SMS, 15 Mo à 150 FCFA",
    validUntil: "1 jour",
    code: "*105*1#",
    type: "Combinée"
  },
  {
    id: 7,
    networkId: 2, // MTN
    title: "Pack Free Mini",
    description: "17 min, 25 SMS, 25 Mo à 200 FCFA",
    validUntil: "1 jour",
    code: "*105*1#",
    type: "Combinée"
  },
  {
    id: 8,
    networkId: 2, // MTN
    title: "Pack Free Mini",
    description: "27 min, 30 SMS, 50 Mo à 300 FCFA",
    validUntil: "3 jours",
    code: "*105*1#",
    type: "Combinée"
  },
  {
    id: 9,
    networkId: 2, // MTN
    title: "Pack Free Maxi",
    description: "50 min, 100 SMS, 250 Mo, appels illimités vers 5 numéros complices à 500 FCFA",
    validUntil: "7 jours",
    code: "*105*1#",
    type: "Combinée"
  },
  {
    id: 10,
    networkId: 2, // MTN
    title: "Pack Free Mois",
    description: "205 min, 300 SMS, 2,5 Go, appels illimités vers 5 numéros complices à 2500 FCFA",
    validUntil: "30 jours",
    code: "*105*1#",
    type: "Combinée"
  },{
    id: 4,
    networkId: 1, // Orange
    title: "Pass Mix Semaine",
    description: "90 min d'appels tous réseaux, 600 Mo d'internet, 300 SMS à 500 FCFA",
    validUntil: "7 jours",
    code: "*144*2#",
    type: "Combinée"
  },
  {
    id: 5,
    networkId: 1, // Orange
    title: "Pass Mix Semaine Plus",
    description: "Avantages du Pass Mix Semaine + accès gratuit à WaW Muzik à 1000 FCFA",
    validUntil: "7 jours",
    code: "*144*2#",
    type: "Combinée"
  }
];

export default comparatifData;